<div class="container simulation-manager">
    <div class="row">
        <div class="col-md-12">
            <h3 class="section-heading">Start Simulation(s)</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-12">
            <form autocomplete="off" id="txtSimulationForm" [formGroup]="customerSearchForm">
                <div class="row row-bottom-space">
                    <div class="col-md-6">
                        <app-alight-drop-down [group]="customerSearchForm" [controlName]="'clientId'" [required]="true"
                            description="clientName" [disable]="rootService.disableDropdown()" label="Client"
                            [value]="'clientId'" [list]="
                      rootService.liveChatCTS.length < 2
                        ? customerService.clients
                        : rootService.liveChatCTS
                    " (change)="onClientDropDownChange($event)">
                        </app-alight-drop-down>
                    </div>
                    <div class="col-md-6">
                        <app-alight-drop-down [group]="customerSearchForm" [controlName]="'similationType'"
                            value="fieldValue" description="fieldValueDescription" label="Simulation Type"
                            [list]="similationTypes" ></app-alight-drop-down>
                    </div>
                </div>

                <div class="row row-bottom-space">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Last Name (Required)</mat-label>
                            <input matInput formControlName="lastName" autocomplete="off" id="lastName" />
                            <mat-error>
                                <i class="fa-solid fa-circle-xmark"></i>
                                Last Name is required.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" id="firstName" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-bottom-space">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
                            <input matInput formControlName="dateOfBirth" autocomplete="off" id="dateOfBirth" />
                            <mat-error>
                                <i class="fa-solid fa-circle-xmark"></i>
                                Date of Birth must be in the MM/DD/YYYY format.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>National ID (Last 4)</mat-label>
                            <input matInput formControlName="nationalId" id="nationalId"/>
                            <mat-error>
                                <i class="fa-solid fa-circle-xmark"></i>
                                Enter the last 4 numbers of National ID.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Employee ID</mat-label>
                            <input matInput formControlName="employeeId" autocomplete="off" id="employeeId" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="component-box ">
                            <mat-label>Postal Code</mat-label>
                            <input matInput formControlName="postalCode" id="postalCode" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-6 col-md-12 simulation-card">
            <f-data-card>
                <div class="simulation-controls flex justify-space-between">
                    <h3> Active Simulation(s) </h3>
                    <a class="end-btn hide" href="#">End all simulations</a>
                </div>
                <section class="error-wrapper hide">
                    <f-alert variant="error">
                        <p> There was a problem loading the data. <button class="btn-alert">Try again</button></p>
                    </f-alert>
                </section>
                <div class="no-result hide">
                    <p>There are no active simulations.</p>
                </div>
                
                <div class="form simulation-row">
                    <!-- Simulation for Call -->
                    <div class=" simulation-data hide">
                        <div class="">
                            <span class="form-label"> Customer Account </span>
                            <span class="form-value"> John Arrowsmith </span>
                        </div>
                        <div class="">
                            <span class="form-label"> Simulation Type </span>
                            <span class="form-value"> <i class="fa fa-phone simulation-icon red"></i>Unknown Call
                            </span>
                        </div>
                        <div class="">
                            <span class="form-label"> Action </span>
                            <span class="form-value"> <f-button text="End Simulation" type="button"
                                    variant="action"></f-button> </span>
                        </div>
                    </div>

                    <!-- Simulation for Chat -->
                    <div class=" simulation-data hide1">
                        <div class="">
                            <span class="form-label"> Customer Account </span>
                           
                        </div>
                        <div class="">
                            <span class="form-label"> Simulation Type </span>
                            
                        </div>
                        <div class="">
                            <span class="form-label"> Action </span>
                            
                        </div>
                    </div>
                    <div class=" simulation-data hide1">
                        <div class="">
                           
                            <span class="form-value"> John Arrowsmith1 </span>
                        </div>
                        <div class="">
                           
                            <span class="form-value"> <i class="fa fa-comment simulation-icon green"></i>Chat </span>
                        </div>
                        <div class="">
                           
                            <span class="form-value"> <f-button text="End Simulation" type="button"
                                    variant="action"></f-button> </span>
                        </div>
                    </div>
                    <div class=" simulation-data hide1">
                        <div class="">
                            
                            <span class="form-value"> John Arrowsmith2 </span>
                        </div>
                        <div class="">
                           
                            <span class="form-value"> <i class="fa fa-comment simulation-icon green"></i>Chat </span>
                        </div>
                        <div class="">
                            
                            <span class="form-value"> <f-button text="End Simulation" type="button"
                                    variant="action"></f-button> </span>
                        </div>
                    </div>
                    <div class=" simulation-data hide1">
                        <div class="">
                           
                            <span class="form-value"> John Arrowsmith3 </span>
                        </div>
                        <div class="">
                           
                            <span class="form-value"> <i class="fa fa-comment simulation-icon green"></i>Chat </span>
                        </div>
                        <div class="">
                            
                            <span class="form-value"> <f-button text="End Simulation" type="button"
                                    variant="action"></f-button> </span>
                        </div>
                    </div>

                </div>


            </f-data-card>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="form-button-controls">
                <f-button text="Clear all" type="button" variant="action"></f-button>
                <f-button text="Search" type="submit" variant="progressive" uuid="txtSearch"></f-button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-4">
            <h3 class="search-result">Search Results</h3>
        </div>
        <!-- <div class="col-md-8">
            <h3 class="display-result">

                Displaying
                <strong> 1 – 10 of 42 </strong> records
            </h3>
        </div> -->
    </div>

    <app-alight-table [dataSource]="dataSource" [totalRecords]="totalRecords" [gridColumns]="Columns" [rowPerPage]="10"
        (rowSelection)="rowSelection($event)" [disableButtons]="rootService.isDuplicateCustSearchTabOpened"
        [hideReplaceAddButton]="false"></app-alight-table>

    <div class="footer-controls">
        <div class="footer-controls-left">
            <f-button text="Start Simulation" type="button" variant="progressive">
            </f-button>
        </div>
    </div>

</div>